module.exports = __webpack_public_path__ + "img/Gavin_Husni.030feafb.png";